export const getValueFromUrl = (urlParams: string, key: string) => {
  const searchParams = new URLSearchParams(urlParams);
  return searchParams.get(key);
};
